// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var _this = this;
var PluginOptions_1 = require("./Base/PluginOptions");
var CoveoForSitecoreBase_1 = require("./Base/CoveoForSitecoreBase");
var TabsBinding_1 = require("./Base/Tabs/TabsBinding");
var Searchbox_1 = require("./Base/Searchbox");
var SearchEndpointHelper_1 = require("./Base/SearchEndpointHelper");
var UserContextHandler_1 = require("./UserContext/UserContextHandler");
var CoveoForSitecoreUserContext = require("./CoveoForSitecoreUserContext");
var CoveoForSitecoreRecommendationsBase_1 = require("./Base/Recommendations/CoveoForSitecoreRecommendationsBase");
exports.OmniboxResultList = require("./Base/OmniboxResultList/OmniboxResultList");
exports.CoveoDistanceResources = require("./CoveoDistanceRessources/CoveoDistanceResources");
var recommendations = new CoveoForSitecoreRecommendationsBase_1["default"]();
exports.userContext = typeof (CoveoForSitecoreUserContext) !== "undefined" ? CoveoForSitecoreUserContext.handler : new UserContextHandler_1["default"]();
exports.componentsOptions = new PluginOptions_1["default"]();
exports.tabsBinding = new TabsBinding_1["default"]();
exports.SearchEndpointHelper = SearchEndpointHelper_1["default"];
exports.defaults = new PluginOptions_1["default"]();
function initializeSearch(searchComponent, options) {
    exports.tabsBinding.applyBindings();
    if (!_isExistingPlugin(searchComponent)) {
        if (typeof (options.userContext) === "undefined") {
            options.userContext = exports.userContext.getContext();
        }
        if (typeof (options.scOverrideOriginWithPageName) === "undefined") {
            options.scOverrideOriginWithPageName = false;
        }
        if (typeof (options.scOverrideCurrentLanguage) === "undefined") {
            options.scOverrideCurrentLanguage = true;
        }
        exports.plugin = new CoveoForSitecoreBase_1["default"](searchComponent, options, exports.defaults);
        exports.plugin.initialize();
    }
}
exports.initializeSearch = initializeSearch;
function initializeSearchbox(searchComponent, options) {
    if (typeof (options.userContext) === "undefined") {
        options.userContext = exports.userContext.getContext();
    }
    exports.plugin = new Searchbox_1["default"](searchComponent, options, exports.defaults);
    exports.plugin.initialize();
}
exports.initializeSearchbox = initializeSearchbox;
exports.initRecommendations = function (element, userContext) {
    recommendations.initRecommendations(element, userContext || _this.userContext.getContext());
};
exports.initRelatedQuery = function (element, searchInterfaceElement, userContext, options) {
    recommendations.initRelatedQuery(element, searchInterfaceElement, userContext || _this.userContext.getContext(), options);
};
function _isExistingPlugin(searchComponent) {
    return exports.plugin && exports.plugin.element && exports.plugin.element.id === searchComponent.id;
}



//////////////////
// WEBPACK FOOTER
// ./CoveoForSitecore.ts
// module id = 2
// module chunks = 0